import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import Activities from "./icons/activities.png";
import Articles from "./icons/articles.png";
import Contact from "./icons/contact.png";
import Organization from "./icons/organization.png";
import Promotions from "./icons/promotions.png";
import Speakers from "./icons/speakers.png";
import Sponsors from "./icons/sponsors.png";
import Ticket from "./icons/ticket.png";
import Venue from "./icons/venue.png";
import Forum from "./icons/forum.png";
import Megaphone from "./icons/megaphone.svg";
import Plus from "./icons/plus.svg";
import Close from "./icons/closeIcon.svg";

export default function Icon({ icon, size = 20 }) {
  return <IconImage src={icons[icon]} width={size} height={size} />;
}

const IconImage = styled.img`
  object-fit: contain;
`;

const icons = {
  activities: Activities,
  articles: Articles,
  contact: Contact,
  organization: Organization,
  promotions: Promotions,
  speakers: Speakers,
  sponsors: Sponsors,
  ticket: Ticket,
  venue: Venue,
  forum: Forum,
  megaphone: Megaphone,
  plus: Plus,
  close: Close,
};

Icon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  icon: PropTypes.oneOf([
    "activities",
    "articles",
    "contact",
    "contact",
    "organization",
    "promotions",
    "speakers",
    "sponsors",
    "ticket",
    "venue",
    "forum",
    "plus",
    "close",
  ]),
};
